import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import "./roles-management-table.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { QuestionCircleFill } from "react-bootstrap-icons";
import AppContext from "../../appContext";
import { XCircleFill, PersonDashFill } from "react-bootstrap-icons";
import CnpjUtils from "../../shared/utils/CnpjUtils";

class RolesManagementTableBodyTr extends Component {
  constructor(props) {
    super(props);


    RolesManagementTableBodyTr.contextType = AppContext;
  }

  removerAcessoUsuario = () => {
    const { removerUsuario, id, cnpj } = this.props;

    removerUsuario(id, cnpj);
  };

  alterarUsuario = e => {
    const { name, value, selectedIndex } = e.target;
    const { alterarPerfilUsuario, id, cnpj } = this.props;

    alterarPerfilUsuario(id, value, e.target.options[selectedIndex].text, cnpj);
  };

  inativarUsuario = () => {
    const { id, email, inativarUsuario } = this.props;

    inativarUsuario(id, email);
  };

  render() {
    const { id, nome, email, perfil, cnpj, cpf, isInativar, inativo, userLogado, erro, papeis } = this.props;
    var desvinculado = papeis.some(elem => {
      return elem.value === perfil;
    });
    var desvinculadoInativo = inativo;

    if (!desvinculado && !cnpj) {
      desvinculadoInativo = !desvinculado;
    }

    var cpfMask = cpf ? cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "";
    var cnpjMask = cnpj ? CnpjUtils.formatCnpj(cnpj) : "";
    return (
      <tr id={id}>
        <td className="roles-management-table-body-tr" style={{fontSize: "0.8rem" }}>{nome}</td>
        <td className="roles-management-table-body-tr" style={{fontSize: "0.8rem" }}>{email}</td>
        <td className="roles-management-table-body-tr" style={{fontSize: "0.8rem" }}>{cpfMask}</td>
        <td className="roles-management-table-body-tr" style={{fontSize: "0.8rem" }}>{cnpjMask}</td>
        <td className="roles-management-table-body-tr" >
          <div className="roles-box">
            <span className="roles-select-arrow"></span>
            <select
              title="Clique nesse campo"
              name="perfil"
              id="perfil"
              value={perfil}
              onChange={this.alterarUsuario}
              className="roles-select"
              disabled={desvinculadoInativo}>
              <option key="0" value="default" disabled selected className="roles-select-option">
                Selecione
              </option>
              {papeis.map((item, index) => (
                <option key={index} value={item.value} className="roles-select-option" disabled={desvinculadoInativo}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>
        </td>
        {(inativo || userLogado) ? (
          <>
            <td colSpan={2} class="text-center align-middle roles-management-table-body-tr" style={{ width: "35%", color: "gray" }}>
              <strong>{erro}</strong>
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip id="button-tooltip">Usuário não pode ser editado.</Tooltip>}>
                <span color="red" className="ms-2" style={{ cursor: "pointer", color: "#0394db" }}>
                  <QuestionCircleFill />
                </span>
              </OverlayTrigger>
            </td>
          </>
        ) : (
          <>
            <td class="text-start align-middle roles-management-table-body-tr" style={{fontSize: "0.8rem" }}>
              <Button id={`roles-unlink-user-${id}`} variant="link" className="btn-excluir ps-5" onClick={this.removerAcessoUsuario} disabled={desvinculadoInativo}>
                <div className="row">
                  <div className="col-4">
                    <XCircleFill color="#0394db" size={25} />
                  </div>
                  <div className="col-8 justify-content-center align-self-center">
                    <p  style={{fontSize: "0.8rem" }}>Desvincular</p>
                  </div>
                </div>
              </Button>
            </td>
            {isInativar && (
              <td class="text-start align-middle roles-management-table-body-tr" style={{fontSize: "0.8rem" }}>
                <Button id={`roles-inactivate-user-${id}`} variant="link" onClick={this.inativarUsuario} className="btn-excluir" disabled={inativo}>
                  <div className="row">
                    <div className="col-4">
                      <PersonDashFill color="red" size={25} />
                    </div>
                    <div className="col-8 justify-content-center align-self-center">
                      <p  style={{fontSize: "0.8rem" }}>Inativar</p>
                    </div>
                  </div>
                </Button>
              </td>
            )}
          </>
        )}
      </tr>
    );
  }
}

export default RolesManagementTableBodyTr;
